import Vue from 'vue';
import Vuex from 'vuex';
import login from '@/modules/login/store';
import auth from '@/store/auth';
import user from '@/store/user';
import criarConta from '@/store/criar-conta';
import listagemCotacao from '@/store/listagem-cotacao';
import painelCotacao from '@/store/painel-cotacao';
import premium from '@/store/premium';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    auth,
    premium,
    user,
    criarConta,
    listagemCotacao,
    painelCotacao,
  },
});
